import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcTwoManBlue = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.42878 5.14265C7.42878 6.40501 6.40543 7.42836 5.14307 7.42836C3.8807 7.42836 2.85735 6.40501 2.85735 5.14265C2.85735 3.88028 3.8807 2.85693 5.14307 2.85693C6.40543 2.85693 7.42878 3.88028 7.42878 5.14265Z",
			fill: "#6C9CFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1431 5.14265C13.1431 6.40501 12.1197 7.42836 10.8574 7.42836C9.59499 7.42836 8.57164 6.40501 8.57164 5.14265C8.57164 3.88028 9.59499 2.85693 10.8574 2.85693C12.1197 2.85693 13.1431 3.88028 13.1431 5.14265Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.14307 9.71408C1.14307 8.7673 1.91058 7.99979 2.85735 7.99979H7.42878C8.37555 7.99979 9.14307 8.7673 9.14307 9.71408V12.5712C9.14307 12.8868 8.88723 13.1426 8.57164 13.1426H1.7145C1.3989 13.1426 1.14307 12.8868 1.14307 12.5712V9.71408Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.85735 9.71408C6.85735 8.7673 7.62486 7.99979 8.57164 7.99979H13.1431C14.0898 7.99979 14.8574 8.7673 14.8574 9.71408V12.5712C14.8574 12.8868 14.6015 13.1426 14.2859 13.1426H7.42878C7.11319 13.1426 6.85735 12.8868 6.85735 12.5712V9.71408Z",
			fill: "#6C9CFA"
		})
	]
});
export default SvgIcTwoManBlue;
